// extracted by mini-css-extract-plugin
export var statItem = "_ln-1";
export var statsRow = "_ln-0";